/* Toprank ship-availability — mark US-only (ready-to-ship) products as unavailable
   on cards + product pages when a non-US ship-to country is selected in the
   announcement bar. Reads the selected country from the theme's
   eurus_delivery_location localStorage and reacts to eurus:delivery-location:updated. */
(function () {
  var KEY = 'eurus_delivery_location';
  var US = 'US';

  function country() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || '{}');
      return (s.countryIso || US).toUpperCase();
    } catch (e) { return US; }
  }

  function isUsOnly(el) {
    var ff = (el.getAttribute('data-ship-ff') || '').toLowerCase();
    return ff === 'ready-to-ship' || el.getAttribute('data-ship-usonly') === 'true';
  }

  function apply() {
    var c = country();
    var nonUS = c !== US;

    /* ---- product cards ---- */
    document.querySelectorAll('a[data-ship-ff]').forEach(function (a) {
      var block = nonUS && isUsOnly(a);
      var card = a.closest('.card-product, li, .product-card, .card') || a;
      card.classList.toggle('ship-blocked', block);
      var media = a.querySelector('.media-gallery, .product-img__wrapper, .card-media') || a;
      var badge = card.querySelector('.ship-block-badge');
      if (block) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ship-block-badge';
          badge.textContent = 'Ships to US only';
          if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
          media.appendChild(badge);
        }
        card.querySelectorAll('.bottom_atc button, .choose-options button, button[name="add"]').forEach(function (b) {
          b.disabled = true; b.classList.add('ship-atc-disabled');
        });
      } else {
        if (badge) badge.remove();
        card.querySelectorAll('.ship-atc-disabled').forEach(function (b) {
          b.disabled = false; b.classList.remove('ship-atc-disabled');
        });
      }
    });

    /* ---- product page add-to-cart ---- */
    document.querySelectorAll('button[name="add"][data-ship-ff]').forEach(function (btn) {
      var block = nonUS && isUsOnly(btn);
      var lbl = btn.querySelector('.button-text') || btn;
      var host = btn.closest('.product-form, form') || btn.parentElement;
      if (block) {
        btn.disabled = true; btn.classList.add('ship-atc-disabled');
        if (!btn.dataset.origLabel) btn.dataset.origLabel = lbl.innerHTML;
        lbl.textContent = 'Not available in ' + c;
        if (host && !host.querySelector('.ship-block-note')) {
          var n = document.createElement('div');
          n.className = 'ship-block-note';
          n.textContent = 'This item ships to the US only. Switch the country to United States, or choose a handcrafted-to-order item for worldwide shipping.';
          (btn.parentElement || host).appendChild(n);
        }
      } else {
        btn.disabled = false; btn.classList.remove('ship-atc-disabled');
        if (btn.dataset.origLabel) { lbl.innerHTML = btn.dataset.origLabel; delete btn.dataset.origLabel; }
        if (host) { var nn = host.querySelector('.ship-block-note'); if (nn) nn.remove(); }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', function () { setTimeout(apply, 120); });
  window.addEventListener('eurus:delivery-location:updated', function () { setTimeout(apply, 0); });
  /* re-apply after collection/section AJAX renders */
  document.addEventListener('eurus:cart:items-changed', function () { setTimeout(apply, 60); });
})();
